import { Action, createReducer } from '@ngrx/store';
import { FormState, initialFormState } from '../../state/form.state';
import { accordionReducer } from './accordion.reducer';
import { customerIdentificationReducer } from './customer-identification.reducer';
import { filterReducer } from './filter.reducer';
import { formOperationsReducer } from './form-operations.reducer';
import { functionalElementsReducer } from './functional-elements.reducer';
import { participantCopiesReducer } from './participant-copies.reducer';
import { spqReducer } from './service-part-questionnaire.reducer';
import { systemConditionReducer } from './system-condition.reducer';
import { manualIndividualizationReducer } from './manual-individualization.reducer';
import { historicalValuesReducer } from './historical-values.reducer';

const createFormReducer = createReducer(
    initialFormState,
    ...formOperationsReducer,
    ...customerIdentificationReducer,
    ...systemConditionReducer,
    ...participantCopiesReducer,
    ...accordionReducer,
    ...functionalElementsReducer,
    ...filterReducer,
    ...spqReducer,
    ...manualIndividualizationReducer,
    ...historicalValuesReducer,
);
export function formReducer(state: Readonly<FormState>, action: Action): Readonly<FormState> {
    return createFormReducer(state, action);
}
